import { type ErrorInfo, type ReactNode, Component } from 'react';
import { type UnregisterCallback } from 'history';

import { history } from '@editor2/history';

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false
	};
	public unregister: UnregisterCallback;

	public static getDerivedStateFromError(_: Error): State {
		// Update state so the next render will show the fallback UI.
		return { hasError: true };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error('Uncaught error:', error, errorInfo);
		if (window.Rollbar) {
			window.Rollbar.error(error);
		}
	}

	componentDidMount(): void {
		this.unregister = history.listen((location, action) => {
			if (this.state.hasError) {
				this.setState({ hasError: false });
			}
		});
	}

	componentWillUnmount(): void {
		this.unregister();
	}

	public render() {
		if (this.state.hasError) {
			return <h2>Sorry, something went wrong.</h2>;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
